import React from "react";

import {
  Box,
  Typography,
  Container,
  Divider,
  Grid,
  Button,
} from "@mui/material";

import { Tribuja } from "../../assets";

const connectedliving = {
  locationimage:
    "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267",

  data: [
    {
      type: "Educational Institutions",

      data: [
        {
          time: "5",
          h1: "Samashti International School",
        },

        {
          time: "8",
          h1: "Birla Open Minds International School",
        },
        {
          time: "12",
          h1: "Gaudium International School",
        },
      ],
    },

     {
      type: "Work Spaces",

      data: [
        {
          time: "15",
          h1: "Financial District",
        },

        {
          time: "18",
          h1: "Neopolis",
        },
        {
          time: "20",
          h1: "Gachibowli IT Hub",
        },
      ],
    },

    {
      type: "Healthcare",

      data: [
        {
          time: "15",
          h1: "Continental Hospital",
        },

        {
          time: "18",
          h1: "AIG Hospitals",
        },
        {
          time: "20",
          h1: "Citizens Hospital",
        },
      ],
    },

    {
      type: "Entertainment",

      data: [
        {
          time: "18",
          h1: "Sarath City Capital Mall",
        },

        {
          time: "20",
          h1: "Inorbit Mall",
        },
        {
          time: "22",
          h1: "IKEA Hyderabad",
        },
      ],
    },

    {
      type: "Connectivity",

      data: [
        {
          time: "12",
          h1: "ORR Exit 2",
        },

        {
          time: "30",
          h1: "RGIA Airport Connectivity via ORR",
        },
      ],
    },
  ],
};

const ConnectedLivingSection = () => {
  const isValid =
    connectedliving &&
    connectedliving.locationimage &&
    connectedliving.data?.length > 0;

  const handleImageClick = () => {
    window.open(
      "https://maps.google.com",
      "_blank"
    );
  };

  return (
    <Box
      sx={{
        width: "100%",

        overflow: "hidden",

        position: "relative",
      }}
    >
      <Box
        sx={{
          position: "relative",

          width: "100%",

          height: "auto",

          backgroundImage: `url("https://dprstorage.b-cdn.net/RW/leadgen/herobg2.webp")`,

          backgroundSize: "cover",

          backgroundPosition: "top center",

          backgroundRepeat: "no-repeat",
        }}
      >
        {/* OVERLAY */}

        <Box
          sx={{
            position: "absolute",

            top: 0,
            left: 0,

            width: "100%",
            height: "100%",

            backgroundColor:
              "rgba(0,0,0,0.6)",

            zIndex: 1,
          }}
        />

        {/* CONTENT */}

        <Box
          sx={{
            position: "relative",

            width: "100%",

            zIndex: 2,

            pt: {
              xs: 6,
              md: 4,
            },

            py: {
              xs: 3,
              md: 4,
            },
          }}
        >
          <Container maxWidth="xl">
            {/* HEADING */}

            <Box
              sx={{
                textAlign: "center",

                color: "white",

                mb: 2,
              }}
            >
              <Typography
               variant="h4"
                        sx={{

                          fontFamily:"Luxury",
                            fontWeight: 500,

                            color: "#fff",

                            letterSpacing: "1px",

                            textTransform: "uppercase",

                            mb: 2,
                        }}
              >
                CONNECTED LIVING
              </Typography>

               <Box
                          sx={{
                            width: {
                              xs: "120px",
                              md: "180px",
                            },
            
                            height: "2px",
            
                            background:
                              "linear-gradient(to right, transparent, #fff, transparent)",
            
                            mx: "auto",
            
                            mb: 3,
                          }}
                        />
            

             
            </Box>
            

            {!isValid ? (
              <Typography
                variant="body2"
                sx={{
                  color: "white",

                  textAlign: "center",

                  fontSize: "18px",

                  fontWeight: 300,

                  letterSpacing: 0.5,

                //   mt: 2,
                }}
              >
                Connected living data is not
                uploaded.
              </Typography>
            ) : (
              <Grid
                container
                spacing={4}
                sx={{
                  justifyContent:
                    "center",

                  alignItems: "center",
                }}
              >
                {/* IMAGE COLUMN */}

                <Grid
                  item
                  xs={12}
                  md={7}
                  sx={{
                    display: "flex",

                    justifyContent:
                      "center",
                  }}
                >
                  <Box
                    sx={{
                      width: "100%",

                      maxWidth: 600,

                      borderRadius: 2,

                      overflow: "hidden",

                      cursor: "pointer",
                    }}
                    onClick={handleImageClick}
                  >
                    <img
                      src="https://dprstorage.b-cdn.net/RW/tribuja/map%20tribhuja.png"
                      alt="Connected Living"

                      style={{
                        width: "100%",

                        height: "auto",

                        borderRadius: 8,
                      }}
                    />
                  </Box>
                </Grid>

                {/* RIGHT SIDE */}

                <Grid
                  item
                  xs={12}
                  md={5}
                >
                  <Grid
                    container
                    spacing={1}
                    sx={{
                      mt: 1,

                      textAlign: "left",
                    }}
                  >
                    {connectedliving.data.map(
                      (group, index) => (
                        <Grid
                          item
                          xs={12}
                          key={index}
                          sx={{
                            mt: 1,
                          }}
                        >
                          <Typography
                            // variant="h6"
                            sx={{
                              fontFamily:"Luxury",
                              fontWeight:
                                "600",

                              fontSize:
                                "14px",

                              color:
                                "white",
                              letterSpacing:"3px",

                              mb: 1,
                            }}
                          >
                            {group.type} 
                          </Typography>

                          <Typography
                            variant="body2"
                            sx={{
                              
                              fontSize:
                                "12px",

                              color:
                                "#f5f5f5",

                              fontWeight:
                                "300",

                              letterSpacing:
                                "1px",
                            }}
                          >
                            {group.data.map(
                              (
                                item,
                                i
                              ) => (
                                <React.Fragment
                                  key={i}
                                >
                                  {
                                    item.time
                                  }{" "}
                                  mins -{" "}
                                  {
                                    item.h1
                                  }{" "}
                                  <br />
                                </React.Fragment>
                              )
                            )}
                          </Typography>
                        </Grid>
                      )
                    )}
                  </Grid>
                </Grid>
              </Grid>
            )}

            {/* BUTTON */}

            {/* <Box
              sx={{
                display: "flex",

                justifyContent:
                  "center",

                mt: 6,
              }}
            >
              <Button
                variant="outlined"
                sx={{
                  color: "white",

                  border:
                    "1px solid white",

                  px: 4,

                  py: 1.5,

                  fontSize: "14px",

                  letterSpacing: "2px",

                  "&:hover": {
                    border:
                      "1px solid white",

                    background:
                      "rgba(255,255,255,0.1)",
                  },
                }}
              >
                VIEW SPECIFICATIONS
              </Button>
            </Box> */}
          </Container>
        </Box>
      </Box>
    </Box>
  );
};

export default ConnectedLivingSection;